var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 161.422 59.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{stroke:url(#Sfumatura_senza_nome_2);}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-2,.cls-3,.cls-4{fill:none;}.cls-3{stroke:url(#Sfumatura_senza_nome_2-2);}.cls-4{stroke:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_2",
    x1: 134.706,
    y1: 47,
    x2: 134.706,
    y2: 2.462,
    gradientTransform: "translate(0 48) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_2-2",
    x1: 26.715,
    x2: 26.715,
    xlinkHref: "#Sfumatura_senza_nome_2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m80.711,58.607c6.096,0,11.038-4.942,11.038-11.038s-4.942-11.038-11.038-11.038-11.038,4.942-11.038,11.038,4.942,11.038,11.038,11.038Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.711,49.852c1.261,0,2.284-1.023,2.284-2.284s-1.022-2.284-2.284-2.284-2.284,1.022-2.284,2.284,1.022,2.284,2.284,2.284Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.966,46.594l-1.484,1.134-1.218,1.553-.114-2.291-.518-2.23,1.599,1.157,1.736.677Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.456,46.594l1.736-.677,1.599-1.157-.518,2.23-.114,2.291-1.218-1.553-1.484-1.134Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m144.627,1c9.919,4.844,15.795,10.854,15.795,17.367,0,12.421-21.374,23.022-51.431,27.171"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m16.795,1C6.876,5.844,1,11.854,1,18.367c0,12.421,21.374,23.022,51.431,27.171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360);
export default __webpack_public_path__ + "static/media/360.a6cb1e3fdcc2c9e429162074364e42a0.svg";
export { ForwardRef as ReactComponent };